// extracted by mini-css-extract-plugin
export default {"divTextToHome":"VerifyEmail_divTextToHome__AGZD7","iconBack":"VerifyEmail_iconBack__37EQA"};